import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=eabb8910"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eabb8910')) {
      api.createRecord('eabb8910', component.options)
    } else {
      api.reload('eabb8910', component.options)
    }
    module.hot.accept("./Pages.vue?vue&type=template&id=eabb8910", function () {
      api.rerender('eabb8910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/Pages.vue"
export default component.exports